import { lcOptions } from '@/app/locales/mapping';
import { UPDATE_LOCALE } from '@/app/store/action-types';
import { resolveLocale } from '@/app/utils/LocaleUtil';
import { getUrlParameter } from '@/app/utils/platformUtils';

import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
// import moment from 'moment';
import Cookie from 'js-cookie';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import updateElementLocale from './ui-kit-locale';

const loadedLocales = [];
const DEFAULT_LOCALE = lcOptions.options.defaultLocaleName;
const LOCALE_QUERY_PARAM_NAME = lcOptions.options.queryLocaleParamName;
const GLOBAL_LOCALES = lcOptions.global;
const LOCALE_COOKIE_NAME = 'locales';
const LOCALE_COOKIE_TTL_DAYS = 365 * 5;

Vue.use(VueI18n);
Vue.use(VueMoment, { moment });

function isCookieEnabled() {
  return typeof navigator !== 'undefined'
    && typeof window !== 'undefined'
    && typeof document !== 'undefined'
    && typeof navigator.cookieEnabled !== 'undefined'
    && navigator.cookieEnabled;
}

export function clientLocale() {
  if (lcOptions.options.queryLocaleResolving) {
    // from the request (?lang=en-US or ?lang=en or ?lang=* or ?lang=ru,en-US,zh,*)
    const queryParamLocale = getUrlParameter(LOCALE_QUERY_PARAM_NAME);
    if (queryParamLocale) {
      return resolveLocale(decodeURIComponent(queryParamLocale), lcOptions.mapping, DEFAULT_LOCALE);
    }
  }

  if (lcOptions.options.cookieLocaleResolving && isCookieEnabled()) {
    // from cookie ('locales'='en-US' or 'locales'='en' or 'locales'=encodeURIComponent('ru,en-US,zh,*'))
    const cookieLocale = Cookie.get(LOCALE_COOKIE_NAME);
    if (typeof cookieLocale !== 'undefined') {
      return resolveLocale(decodeURIComponent(cookieLocale), lcOptions.mapping, DEFAULT_LOCALE);
    }
  }

  if (lcOptions.options.browserLocaleResolving) {
    // from the browser default language settings ('en-US' or 'en' or '*')
    if (typeof navigator !== 'undefined' && navigator.language !== 'undefined') {
      return resolveLocale(navigator.language, lcOptions.mapping, DEFAULT_LOCALE);
    }
  }

  return DEFAULT_LOCALE;
}

export async function loadLocale(localeLoader, { i18n, locale, moduleName }) {
  const localeId = `${moduleName}_${locale}`;

  if (!loadedLocales.includes(localeId)) {
    try {
      let locales;
      try {
        locales = await localeLoader(locale);
      } catch (e) {
        locales = await localeLoader(DEFAULT_LOCALE);
      }

      if (locales && locales.dateTimeFormats) {
        i18n.mergeDateTimeFormat(locale, locales.dateTimeFormats);
      }

      if (locales && GLOBAL_LOCALES) {
        i18n.mergeLocaleMessage(locale, GLOBAL_LOCALES);
      }

      if (locales && locales.messages) {
        i18n.mergeLocaleMessage(locale, locales.messages);
      }

      if (locales) {
        loadedLocales.push(localeId);
      }

      if (locales && locales.pluralizationRules) {
        i18n.pluralizationRules[locale] = locales.pluralizationRules;
      }
    } catch (err) {
      console.log('Load module "', moduleName, '" locale file ', err);
    }
  }

  return Promise.resolve();
}

export function setupI18n(store) {
  const selectedLocale = clientLocale();
  const htmlElement = document.getElementsByTagName('html')[0];

  const i18n = new VueI18n({
    locale: selectedLocale,
    fallbackLocale: DEFAULT_LOCALE,
    silentTranslationWarn: process.env.NODE_ENV === 'production'
  });

  htmlElement.lang = selectedLocale;

  store.watch(state => state.locale, async (locale) => {
    updateElementLocale(locale);
    // moment.locale(locale);
    Vue.moment.locale(locale);
    await loadLocale(appLocale => import(`@/app/locales/${appLocale}`), { i18n, locale, moduleName: 'app' });
    i18n.locale = locale;
    htmlElement.lang = locale;

    if (lcOptions.options.cookieSaveActiveLocale && isCookieEnabled()) {
      Cookie.set(LOCALE_COOKIE_NAME, locale, { expires: LOCALE_COOKIE_TTL_DAYS, sameSite: 'lax' });
    }
  });

  store.dispatch(UPDATE_LOCALE, selectedLocale);
  return i18n;
}

export async function setupModuleI18n(app, moduleName, localeLoader) {
  const i18n = app.$i18n;
  const currentLocale = app.$store.state.locale;

  await loadLocale(localeLoader, { i18n, locale: currentLocale, moduleName });
  i18n.locale = 'tmp';// hack;
  i18n.locale = currentLocale;

  app.$store.watch(state => state.locale, async (locale) => {
    await loadLocale(localeLoader, { i18n, locale, moduleName });
    i18n.locale = 'tmp';// hack;
    i18n.locale = locale;
  });
}
